// Module
var code = "<div class=\"col-md-10 col-md-offset-1\"> <h2>Authentication error</h2> <p class=\"lead\"> An error occurred while checking your authentication details. Please try again later. </p> <p> <button data-bind=\"click: logout\" class=\"btn btn-primary mt-3\">Logout</button> </p> </div> ";
// Exports
export default code;